import React from 'react';

const SuspenseContainer = () => {
  const styles = { height: '100vh', backgroundColor: 'white' };
  return <div style={styles}>Loading...</div>;
};

export default SuspenseContainer;
